import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-register-account',
  templateUrl: './register-account.component.html',
  styleUrls: ['./register-account.component.scss']
})
export class RegisterAccountComponent implements OnInit {

  formRegistro: FormGroup;
  loader: boolean = false;
  error: string;
  googleCaptchaSiteKey = environment.googleCaptchaSiteKey;
  googleCaptchaResponse: string;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private gaService: GoogleAnalyticsService
  ) {

    this.formRegistro = this.fb.group({
      nombreEmpresa: ['', [Validators.required]],
      telefonoEmpresa: ['', [Validators.required]],
      nombreUsuario: ['', [Validators.required]],
      emailUsuario: ['', [Validators.required]],
      rutCliente: ['', [Validators.required]],
      rutEmpresa: ['', [Validators.required]],
      recaptchaReactive: ['', [Validators.required]]
    });

  }

  ngOnInit(): void {
  }

  resolved(event) {
    this.googleCaptchaResponse = event;
    //console.log("RESPUESTA RECAPTCHA: ", event);
  }

  async registrar() {
    if (this.formRegistro.valid) {
      try {
        this.loader = true;
        const body = this.formRegistro.value;
        body.RecaptchaResponse = this.googleCaptchaResponse;

        const response = await this.authService.formularioSolicitudAcceso(body);
        if (response.error.codError === 0) {
          //recupero ok
          this.gaService.event('Envio Solicitud Exitosa', 'Envío solicitud registro', 'Acceso');
          this.gaService.pageView('/Envio-Solicitud-Exitosa');
          this.router.navigate(['/auth']);
        }
        else {
          this.formRegistro.controls["recaptchaReactive"].setValue("");
          console.log("Error en Solicitar acceso: ", response.error.desError);
          this.gaService.event('Envio Solicitud Fallida', 'Envío solicitud registro', 'Acceso');
          this.gaService.pageView('/Envio-Solicitud-Fallida');
          this.error = response.error.desError;
        }
      } catch (error) {
        this.formRegistro.controls["recaptchaReactive"].setValue("");
        this.gaService.event('Envio Solicitud Fallida', 'Envío solicitud registro', 'Acceso');
        console.error(error);
      } finally {
        this.loader = false;
      }
    }
  }

}
